"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var homerEgg = {
    name: "homer",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["h", "o", "m", "e", "r"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/7EXwuS0.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "350px";
        img.style.height = "350px";
        img.style.transition = "4s all";
        img.style.position = "fixed";
        img.style.left = "-400px";
        img.style.bottom = "calc(-50% + 320px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 4300);
    },
};
exports.default = homerEgg;
